import { Component, input } from '@angular/core';

import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';

@Component({
  selector: 'app-order-details-page-header',
  templateUrl: './order-details-page-header.component.html',
  standalone: false,
})
export class OrderDetailsPageHeaderComponent {
  textColor = input<IContentBuilderFieldColor>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  backgroundColor = input<IContentBuilderFieldColor>({
    value: '#FFFFFF',
    type: ColorFieldTypesValues.Hex,
  });

  constructor(private readonly navigationHistoryService: NavigationHistoryService) {}

  back(): void {
    this.navigationHistoryService.goBack();
  }
}
